// 钉钉登录后中间页
<template>
  <div>
    <!--用户后台首页内容-->
    <div class="enterprise_box" @click="toAuth">
      <!-- 左边盒子   -->
      <div class="left_content">
        <div class="launch_contract_box">
          <div class="launch_img">
            <div class="add_btn">
              <img class="add_img" src="../../static/images/home/add_red.png" alt />
              <img class="hover_add_img" src="../../static/images/home/add.png" alt />
              <span>发起签署</span>
            </div>
            <p class="add_p">
              支持
              <span class="add_span">上传文件</span>及
              <span class="add_span">使用模板</span>发起签署
            </p>
          </div>
        </div>
        <!--  数据内容    -->
        <ul class="contract_data">
          <li
            class="contract_data_li"
            v-if="allAuthUser.bindCorpUsers && !allAuthUser.bindCorpUsers.length && allAuthUser && !isInDingTalk"
          >
            <p class="title">
              <img class="lament_img" src="../../static/images/home/lament_img.png" alt />
              <span>当前尚未加入/创建企业</span>
            </p>
            <div class="join_card">
              <img class="no_join" src="../../static/images/home/no_join.png" alt />
              <div class="join_content">
<!--                <p class="join_title">当前还未加入/创建企业</p>-->
                <p class="join_title">当前还未加入企业</p>
<!--                <p class="join_grey">加入/创建企业可代表企业签署及管理合同</p>-->
                <p class="join_grey">加入企业可代表企业签署及管理合同</p>
                <div class="join_btn">
                  <div class="btn_one">加入企业</div>
<!--                  <div class="btn_one">创建企业</div>-->
                </div>
              </div>
            </div>
          </li>
          <!--    未加入企业-->
          <template v-if="authUser.identityAuth > -1">
            <li
              class="contract_data_li"
              v-for="(item, index) in allAuthUser.notBindCorpUsers"
              :key="index"
              v-show="!isInDingTalk || (isInDingTalk && item.userStemFrom === -16)"
            >
              <div class="join_tip">待加入</div>
              <div class="title flex_title">
                <div>
                  <span class="block"></span>
                  <img
                    src="/images/icon/dingIcon.png"
                    alt="钉钉"
                    width="20px"
                    v-if="item.userStemFrom === -16 && !isInDingTalk"
                  />
                  {{item.corpName || "&nbsp;"}}
                </div>
              </div>
              <div class="li_content">
                <div class="bottom">
                  <img src="/images/web/join.png" />
                  <p>
                    该企业邀请您成为企业成员，
                    <a class="com-link">立即加入&gt;&gt;</a>
                  </p>
                </div>
              </div>
            </li>
          </template>

          <!--   加入的     -->
          <template v-if="authUser.identityAuth > -1">
            <li
              class="contract_data_li"
              v-for="(item, index) in allAuthUser.bindCorpUsers"
              :key="index"
              v-show="(isInDingTalk && dingInfo.jzqCorpId === item.corpId) || !isInDingTalk"
            >
              <div class="join_tip">加入的</div>
              <div class="title flex_title">
                <div>
                  <span class="block"></span>
                  <img
                    src="/images/icon/dingIcon.png"
                    alt="钉钉"
                    width="20px"
                    v-if="item.userStemFrom === -16 && !isInDingTalk"
                  />
                  {{item.corpName || "&nbsp;"}}
                </div>
                <span v-if="isInDingTalk" class="title_console">
                  <i class="el-icon-setting recharge_icon"></i>
                  企业控制台
                </span>
                <span v-else></span>
              </div>
              <div class="li_content">
                <div class="li_once">
                  <div class="img_box">
                    <img class="li_img" src="../../static/images/home/signed_img.png" alt />
                  </div>
                  <div class="li_text">
                    <p class="p">
                      <!--                      {{ (corpInfo.signCount[item.corpUserId] &&corpInfo.signCount[item.corpUserId].noFinishCount) ||0 }}-->
                      {{corpInfo.signCount[item.corpUserId] ? signNumberFn([corpInfo.signCount[item.corpUserId].noFinishCount, corpInfo.signCount[item.corpUserId].myApplyNotSelfSignCount, corpInfo.signCount[item.corpUserId].ccToMeSignCount]) : 0}}
                    </p>
                    <span>待签署</span>
                  </div>
                </div>
                <div class="li_once">
                  <div class="img_box">
                    <img class="li_img" src="../../static/images/home/approve_img.png" alt />
                  </div>
                  <div class="li_text">
                    <p
                      class="p"
                    >{{ corpInfo.signCount[item.corpUserId] ? signNumberFn([statistics(item)]) : 0 }}</p>
                    <span>待审批</span>
                  </div>
                </div>
                <div class="li_once">
                  <div class="img_box">
                    <img class="li_img" src="../../static/images/home/end_img.png" alt />
                  </div>
                  <div class="li_text">
                    <p class="p">
                      <!--                      {{ corpInfo.signCount[item.corpUserId] ? signNumberFn([statistics(item)]) : 0 }}-->
                      {{ corpInfo.signCount[item.corpUserId] ? signNumberFn([corpInfo.signCount[item.corpUserId].myFinishCount, corpInfo.signCount[item.corpUserId].ccToMeFinishCount, corpInfo.signCount[item.corpUserId].selfSignFinishCount]) : '' }}
                    </p>
                    <span>已结束</span>
                  </div>
                </div>
              </div>
            </li>
          </template>
          <template v-else>
            <li
              class="contract_data_li"
              v-for="(item, index) in allAuthUser.bindCorpUsers"
              :key="index"
              v-show="(isInDingTalk && dingInfo.jzqCorpId === item.corpId) || !isInDingTalk"
            >
              <div class="join_tip">加入的</div>
              <div class="title">
                <span class="block"></span>
                <img
                  src="/images/icon/dingIcon.png"
                  alt="钉钉"
                  width="20px"
                  v-if="item.userStemFrom === -16 && !isInDingTalk"
                />
                {{item.corpName || "&nbsp;"}}
              </div>
              <div class="li_content">
                <div class="li_once">
                  <div class="img_box">
                    <img class="li_img" src="../../static/images/home/signed_img.png" alt />
                  </div>
                  <div class="li_text">
                    <p class="p">--</p>
                    <span>待签署</span>
                  </div>
                </div>
                <div class="li_once">
                  <div class="img_box">
                    <img class="li_img" src="../../static/images/home/approve_img.png" alt />
                  </div>
                  <div class="li_text">
                    <p class="p">--</p>
                    <span>待审批</span>
                  </div>
                </div>
                <div class="li_once">
                  <div class="img_box">
                    <img class="li_img" src="../../static/images/home/end_img.png" alt />
                  </div>
                  <div class="li_text">
                    <p class="p">--</p>
                    <span>已结束</span>
                  </div>
                </div>
                <!--                <div-->
                <!--                  class="li_once">-->
                <!--                  <div class="img_box">-->
                <!--                    <img class="li_img" src="../../static/images/home/manage_img.png" alt="">-->
                <!--                  </div>-->
                <!--                  <div class="li_text">-->
                <!--                    <p class="other_p">企业控制台</p>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </li>
          </template>
          <!--   自己     -->
          <li class="contract_data_li">
            <!--            <div class="join_tip">我自己</div>-->
            <p class="title">
              <span class="block"></span>
              {{getUserName}}
            </p>
            <div class="li_content">
              <div class="li_once">
                <div class="img_box">
                  <img class="li_img" src="../../static/images/home/signed_img.png" alt />
                </div>
                <div class="li_text">
                  <p
                    class="p"
                  >{{ signNumberFn([signCount.noFinishCount, signCount.myApplyNotSelfSignCount, signCount.ccToMeSignCount]) }}</p>
                  <span>待签署</span>
                </div>
              </div>
              <div class="li_once">
                <div class="img_box">
                  <img class="li_img" src="../../static/images/home/end_img.png" alt />
                </div>
                <div class="li_text">
                  <p class="p">{{ signNumberFn([signCount.finishCount, signCount.myFinishCount])}}</p>
                  <span>已结束</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 右边用户   -->
      <div class="right_user">
        <!--用户、 产品公告 和 广告    -->
        <bannerList :authDialog.sync="authDialog" />
      </div>
    </div>
  </div>
</template>

<script>
// * 组件
import bannerList from './components/bannerList.vue';
import { mapGetters } from "vuex";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";

export default {
  data () {
    return {
      isInDingTalk,
      dingInfo: null, // 钉钉环境字段
      // 账户类型 0 个人 1 企业
      userType: 0,
      signCount: {
        noFinishCount: 0,
        finishCount: 0,
        draftBoxCount: 0,
        myCreateCount: 0
      },
      corpInfo: {
        signCount: {}, // 加入企业的已完成，未完成，草稿箱数量
        pointCnt: {}, // 加入企业的积分
        remainCnt: {} // 套餐剩余数
      },
      authDialog: false,
    };
  },
  computed: {
    // 新增状态辅助函数减少冗余代码
    ...mapGetters(["allAuthUser", "currentAuthUser", 'authUser']),
    getUserName () {
      console.log('this.allAuthUser', this.allAuthUser);
      if (this.loginUser) {
        return (
          this.loginUser.name ||
          this.loginUser.username ||
          this.loginUser.emailMask ||
          this.loginUser.mobileMash
        );
      } else {
        return '';
      }
    },
    loginUser () {
      return this.allAuthUser
        ? this.allAuthUser.accountInfoVO
        : {};
    },
    isDingCorp () {
      // 钉钉环境
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      if (isInDingTalk) {
        return info.jzqCorpId
      }
    },
    currentIsCorpUser () {
      // 当前是否是集团账户
      if ((this.currentAuthUser || {}).hasOwnProperty("superFlag")) {
        return true;
      }
      return false;
    },
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
  },
  mounted () {
    // 是否管理员  sys true 是 false 否
    this.dingInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
    this.toAuth();
  },
  methods: {
    // 实名认证弹窗
    toAuth () {
      const { corpAuthed, personAuthed,jzqEntToken } = this.dingInfo;
      // 企业实名认证
      // if (jzqEntToken && corpAuthed != 1) {
      //   // 如果是之前填写过账号信息。认证中断
      //   this.$router.push({
      //     path: "/dingtalkUse/middlePage",
      //     query: { ap: "/auth/authGuide", t: jzqEntToken }
      //   });
      // }else
      if (corpAuthed != 1) {
        this.EntAuth()
      } else if (personAuthed != 1) {
        this.PersonAuth()
      }
    },
    /** 个人实名 */
    PersonAuth () {
      const
        _this = this,
        conentText = '企业信息已核实，为了确保您可以代表企业进行签署，依据国家《电子签名法》及《电子认证服务管理办法》相关要求，请完成个人身份信息认证！',
        currTips ="你的企业开通了钉钉高级认证，已直接完成了企业认证,请继续续完成企业成员身份认证",
        currAuth = sessionStorage.getItem('isCurrentCorpAuth'),
        message = currAuth ? currTips : conentText;
      _this.$confirm(message, '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '快速认证',
        cancelButtonText: '君子签账号认证',
        dangerouslyUseHTMLString: true
      }).then(() => {
        sessionStorage.removeItem('isCurrentCorpAuth');
        _this.bandByDing();
      }).catch((action ) => {
        action === 'cancel' && _this.bandBySaaS()
      })
    },
    /** 企业实名 */
    EntAuth () {
      const adminStr = '<p>您的企业还未完成实名认证，<span style="color: #ec1c1c;">3分钟完成认证</span>立赠10份合同套餐，享合同签署【免费体验】</p>',
        str = '<p>您的企业还未完成实名认证，君子签赠送您10份合同套餐，请联系企业钉钉管理员完成证。</p>',
        { dingInfo } = this, _this = this;
      const conentText = dingInfo && dingInfo.sys ? adminStr : str;
      this.$confirm(adminStr, '提示', {
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: true,
        confirmButtonText: '快速认证',
        cancelButtonText: '君子签账号认证',
      }).then(() => {
        _this.bandByDing();
      }).catch((action) => { action === 'cancel' && _this.bandBySaaS(); })
    },
    // saas 绑定 start
    bandBySaaS () {
      const { corpAuthed } = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      // * 判断用户实名状态，如果企业【corpAuthed】未实名走企业逻辑，反之个人认证逻辑
      this.$router.push({ path: corpAuthed != 1 ? '/auth/dingTalkAuthComponents/saasBand' : '/auth/dingTalkAuthComponents/personAuth/saasPersonBand' })
    },
    // saas 绑定 end
    // 钉钉快速认证start
    bandByDing () {
      const { dingTalkCorpId: corpId, dingTalkUserId, corpAuthed } = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      // * 判断用户实名状态，如果企业【corpAuthed】未实名走企业逻辑，反之个人认证逻辑
      if (corpAuthed != 1) {
        let loading = this.$loading({
            lock: true,
            text: "认证中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, .5)"
          });
        // 企业未实名
        dingtalkApi.entAutoReplenish({ corpId, dingTalkUserId }).then(res => {
          if (!res.success) { return this.turnOther({ text: res.description }) }
          if (res.data.identityAuth === 1) this.$message.success('企业认证成功！')
          // 记录是否当前用户进行的企业认证，用于个人认证提示语展示不同内容
          sessionStorage.setItem('isCurrentCorpAuth', 1);
          // 进入个人认证页面
          this.$router.replace({ path: '/login/middle', query: { corpId } })
        }).finally(()=>loading.close())
      } else {
        // 进入个人快速认证
        this.$router.push({ path: "/dingtalkUse/personAuth" })
      }
    },
    /** 企业完善资料 */
    turnOther ({ text }) {
      const _this = this, { dingTalkUserId, dingTalkCorpId: corpId } = JSON.parse(sessionStorage.getItem("dingloginInfo"));;
      // _this.$confirm(
      //   text, '提示',
      //   {
      //     distinguishCancelAndClose: true,
      //     dangerouslyUseHTMLString: true,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   }
      // )
      //   .then(() => {
          let loading = _this.$loading({
            lock: true,
            text: "正在登录",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, .5)"
          });
          const param = {
            dingTalkUserId,
            corpId,
            // email (应该是有接口返回邮箱)
          }
          dingtalkApi.entReplenish(param).then(res => {
            if (!res.success) {
              if (res.code === '10302') return _this.$message.error('当前账号已在君子签注册，请前往绑定')
              return _this.$message.error(res.description);
            }
            _this.$router.push({
              path: "/dingtalkUse/middlePage",
              query: { ap: "/auth/authGuide", t: res.data.jzqToken }
            }, () => { });
          }).finally(() => {
            loading.close()
          })
          /* // 钉钉未完成实名
          _this.$router.push({ path: "/auth/dingTalkAuthComponents/dingentAuth" }); */
        // })
        // .catch(() => { });
    },
    // 钉钉快速认证end
    signNumberFn (arr) {
      return arr.reduce((prev, next) => {
        return prev + Number(next ? next : 0);
      }, 0)
    },
    /** 待审批数量统计 */
    statistics (item) {
      const countInfo = this.corpInfo.signCount[item.corpUserId]
      if (!countInfo) return 0
      let count = countInfo.approveSignCount || 0;
      return (countInfo && countInfo.approveCount + (count || 0)) || 0
    },
  },
  name: "index",
  components: {
    bannerList,
  },
  head () {
    return {
      title: "我的首页",
    };
  },
  layout: "defaultStatc",
};
</script>

<style lang="less" scoped>
@import (less) "../../assets/style/icon.css";
.enterprise_box {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .left_content {
    width: 912px;
    border-radius: 10px;
    margin-right: 10px;
    .launch_contract_box {
      background-color: #ffffff;
      padding: 10px;
      .launch_img {
        height: 210px;
        background-image: url("../../static/images/home/launch_contract.png");
        background-size: cover;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .add_btn {
          width: 210px;
          height: 45px;
          border-radius: 45px;
          background: rgba(236, 28, 28, 0.15);
          color: #ec1c1c;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          cursor: pointer;
          &:hover {
            background-color: #ec1c1c;
            color: #ffffff;
            .hover_add_img {
              display: inline-block;
              max-width: 17px;
              vertical-align: text-bottom;
              margin-right: 6px;
            }
            .add_img {
              display: none;
            }
          }
          .add_img {
            max-width: 17px;
            vertical-align: text-bottom;
            margin-right: 6px;
          }
          .hover_add_img {
            display: none;
          }
        }
        .add_p {
          margin-top: 15px;
          font-size: 12px;
          .add_span {
            color: #ec1c1c;
          }
        }
      }
    }
    .contract_data {
      .contract_data_li {
        background-color: #ffffff;
        margin-top: 5px;
        position: relative;
        .join_tip {
          font-size: 12px;
          color: #290202;
          background-color: #e0e0e0;
          padding: 10px 2px;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          flex-wrap: wrap;
          border-radius: 4px 0 0 4px;
          position: absolute;
          top: 0;
          left: -21px;
          letter-spacing: 6px;
          writing-mode: vertical-rl;
        }
        .join_card {
          display: flex;
          justify-content: flex-start;
          padding: 36px 0 36px 68px;
          .no_join {
            width: 280px;
            height: 150px;
            flex-shrink: 0;
            margin-right: 22px;
          }
          .join_content {
            padding-top: 20px;
            .join_title {
              font-weight: bold;
              font-size: 16px;
              color: #1d0000;
            }
            .join_grey {
              font-size: 14px;
              color: rgba(29, 0, 0, 0.75);
              margin: 10px 0 20px 0;
            }
            .join_btn {
              font-weight: 500;
              font-size: 12px;
              color: #ec1c1c;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .btn_one {
                text-align: center;
                font-size: 13px;
                width: 125px;
                padding: 3px;
                border-radius: 18px;
                background: rgba(236, 28, 28, 0.15);
                color: #ec1c1e;
                margin-right: 11px;
                cursor: pointer;
                &:hover {
                  background: #ec1c1e;
                  color: #ffffff;
                }
              }
            }
          }
        }
        .title {
          font-weight: bold;
          font-size: 16px;
          color: #1d0000;
          padding: 15px 0;
          border-bottom: 1px solid #f1f2fb;
          &.flex_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title_console {
              cursor: pointer;
              font-weight: 400;
              margin-right: 30px;
              font-size: 14px;
              &:hover {
                color: #ec1c1c;
              }
            }
          }
          .lament_img {
            max-width: 16px;
            margin: 0 10px;
            vertical-align: baseline;
          }
          .block {
            width: 4px;
            height: 14px;
            background: #1d0000;
            display: inline-block;
            margin-right: 15px;
          }
        }
        .console_box {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 24px 0 27px 0;
          .console_li {
            .console_img {
              width: 298px;
              height: 172px;
              flex-shrink: 0;
              margin-right: 110px;
            }
            .console_seal_tem {
              margin: 10px 0 20px 0;
              font-size: 14px;
              color: rgba(29, 0, 0, 0.75);
            }
            .console_title {
              font-weight: bold;
              font-size: 16px;
              color: #1d0000;
              .red_color {
                color: #ec1c1c;
              }
            }
            .in_console {
              width: 210px;
              border-radius: 18px;
              border: 1px solid #ec1c1c;
              text-align: center;
              padding: 4px 0;
              color: #da4714;
              font-size: 12px;
              .more_icon {
                flex-shrink: 0;
                max-width: 10px;
                margin-left: 10px;
                vertical-align: baseline;
              }
            }
          }
        }
        .li_content {
          padding: 56px 0 47px 0;
          display: flex;
          justify-content: space-around;

          .li_once {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            padding: 17px 40px 0 32px;
            border-radius: 10px;
            &:hover {
              box-shadow: 0 0 15px 1px rgba(236, 28, 28, 0.3);
              .li_text {
                color: #ec1c1c;
                .other_p {
                  color: #ec1c1c;
                }
                .p {
                  color: #ec1c1c;
                }
              }
            }
            .img_box {
              width: 83px;
              height: 103px;
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              .li_img {
                max-width: 60px;
              }
            }
            .li_text {
              font-weight: 500;
              font-size: 14px;
              color: rgba(29, 0, 0, 0.75);
              .in_enter {
                margin-top: 4px;
                width: 93px;
                height: 24px;
                border-radius: 18px 18px 18px 18px;
                border: 1px solid #ec1c1c;
                line-height: 24px;
                text-align: center;
                font-weight: 500;
                font-size: 12px;
                color: #ec1c1c;
                .in_more {
                  width: 10px;
                  height: 10px;
                  margin-left: 6px;
                  vertical-align: baseline;
                }
              }
              .other_p {
                font-weight: bold;
                font-size: 15px;
                color: #1d0000;
                text-align: center;
              }
              .p {
                font-weight: bold;
                font-size: 20px;
                color: #1d0000;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .right_user {
    border-radius: 10px;
    width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/login/dingMiddle.vue